var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm4.853 15.439a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0L12 13.414l-3.439 3.439a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707L10.586 12 7.147 8.561a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0L12 10.586l3.439-3.439a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707L13.414 12z",
    fill: "#646464",
    opacity: 0.6
  })));
}

export default SvgCloseCircle;